import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  NavigationExtras,
} from '@angular/router';

import { Helper } from '../helper';

@Injectable()
export class GuardService implements CanActivate {
  type: string;
  superClinicId: string;
  preselectedClinic: string;
  service: string;
  singleClinic: string;

  constructor(private router: Router, public helper: Helper) {}

  canActivate(route: ActivatedRouteSnapshot) {
    const queryParams = route.queryParams;

    this.type = queryParams.type;
    this.preselectedClinic = queryParams.clinics;
    this.superClinicId = queryParams.superClinicId;
    this.service = queryParams.service;
    this.singleClinic = queryParams.singleClinic;

    const current_user: any = this.helper.getStorage('currentUser');

    if (
      current_user &&
      current_user.data.email &&
      current_user.data.email !== undefined &&
      current_user.data.CPRNumber &&
      current_user.data.CPRNumber !== undefined
    ) {
      return true;
    } else {
      if (
        current_user &&
        (current_user.data.email === undefined ||
          current_user.data.email === null ||
          current_user.data.CPRNumber === '' ||
          current_user.data.CPRNumber === undefined ||
          current_user.data.CPRNumber === null) &&
        route.url[0].path === 'profile'
      ) {
        return true;
      }
    }

    const params = {
      type: this.type,
      service: this.service,
      singleClinic: this.singleClinic,
    };

    // if superclinic and superclinic + service flow, send params to next page
    if (this.superClinicId) {
      params['superClinicId'] = this.superClinicId;
    }

    // if singleclinic flow, send clinics params to next page
    if (this.singleClinic === 'true') {
      params['clinics'] = this.preselectedClinic;
    }

    const navigationExtras: NavigationExtras = {
      queryParams: params,
    };

    this.router.navigate(['/login'], navigationExtras);

    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/guard.service.ts